<template>
  <div
    class="shrink-0 overflow-hidden bg-line"
    :style="{ backgroundColor: project.bgColor }"
  >
    <img
      v-if="project.backgroundUrl && project.backgroundShort"
      :src="project.backgroundShort"
      alt=""
      class="block size-full object-cover"
    >
  </div>
</template>

<script setup>
defineProps({
  project: {
    type: Object,
    required: true,
  },
});
</script>
